module.exports = require("core-js-pure/stable/instance/for-each");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/for-each.js
// module id = 2857
// module chunks = 25